
export enum AuthAccessCheckType {
    All = "All", 
    Any = "Any", 
    Nothing = "Nothing"
}